import React from 'react';
import { RouterProvider } from 'react-router-dom';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import ALL_ROUTES from './router';
import { ToastContainer } from 'react-toastify';
import { DEFAULT_TOAST_OPTIONS } from '@cokitchen/cokitchen-components';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.Fragment>
    <ToastContainer {...DEFAULT_TOAST_OPTIONS} />
    <RouterProvider router={ALL_ROUTES} />
  </React.Fragment>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
